export const TabAcceptRenovationHelpers = {
  data() {
    return {
      tableColumns: [
        {
          title: this.$t("Expediente"),
          type: "text",
          key: "record",
        },
        {
          title: this.$t("Tipo solicitud"),
          type: "text",
          key: "activity_name",
        },
        {
          title: this.$t("Tipo acreditación"),
          type: "text",
          key: "type_name",
        },
        {
          title: this.$t("Fecha plan de mantenimiento"),
          type: "text",
          key: "maintenance_date",
        },
        {
          title: "Días Disponibles",
          type: "custom-html",
          key: "eval_test_time",
          modifier: (value) => {
            let tmp;
            if (value) {
              if (value.remaining_days > 1) {
                tmp = `<span class="badge badge-sm badge-pill badge-success">${value.remaining_days}</span>`;
              }
              if (value.remaining_days == 1) {
                tmp = `<span class="badge badge-sm badge-pill badge-warning">${value.remaining_days}</span>`;
              }
              if (value.remaining_days == 0) {
                tmp = `<span class="badge badge-sm badge-pill badge-danger">${value.remaining_days}</span>`;
              }
            }
            return tmp;
          },
        },
        {
          title: this.$t("Fecha actualización"),
          type: "custom-html",
          key: "updated_at",
          modifier: (value) => {
            if (value) {
              return moment(value).format("YYYY-MM-DD");
            }
          },
        },
      ],
      actionObj: {
        title: this.$t("Acciones"),
        type: "action",
      },
    };
  },
};
